// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-8 px-4 bg-light-gray text-primary text-center">
      <p>
        © {new Date().getFullYear()} Rueda de la Vida. All rights reserved. 
        <span className="mx-2">|</span>
        <Link to="/waiver" className="hover:underline">Legal</Link>
      </p>
    </footer>
  );
};

export default Footer;